import React from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';
import Headline from '@components/atoms/headline/headline';
import Container from '@components/layout/container/container';
import ShapedImage from '@components/molecules/shaped-image/shapedImage';
import { ArrowRight } from '@components/icons/arrow/arrow';
import Link from 'next/link';
import StyledTargetGroups from './targetGroups.style';

const TargetGroups = ({
  data = {
    headline: '',
    targetGroupBlocks: []
  }
}) => {
  const t = useTranslations();
  return (
    <StyledTargetGroups aria-label={data.headline || ''}>
      <Container large id={data.id}>
        {data.headline && (
          <div className="target-groups__headline">
            <Headline primary>{data.headline}</Headline>
          </div>
        )}
        <div className="target-groups__grid">
          {data.targetGroupBlocks &&
            data.targetGroupBlocks.length > 0 &&
            data.targetGroupBlocks.map((item, index) => {
              const isMaxed = data.targetGroupBlocks.length === 3;
              let shape = null;
              let modIndex = index;
              let shadow;

              if (!isMaxed) {
                modIndex = index + 1;
              }

              if (isMaxed && modIndex === 0) {
                shape = 'polygon(0 9%, 80% 0, 100% 11%, 92% 100%, 25% 100%, 0 91%)';
              } else if (modIndex === 1) {
                shape = 'polygon(39% 0, 100% 34%, 90% 100%, 9% 100%, 0% 38%)';
                shadow = 'left';
              } else if (modIndex === 2) {
                shape = 'polygon(39% 0, 100% 34%, 90% 100%, 9% 100%, 0% 38%)';
                shadow = 'right';
              }

              return (
                <div
                  key={item.id}
                  className={`target-groups__grid-item ${modIndex !== 0 && 'half-grid'}`}
                >
                  {item.featuredImage[0] && item.featuredImage[0].url && (
                    <ShapedImage
                      hoverEffect={false}
                      colorScheme={item.colorScheme}
                      shadow={shadow}
                      clipForm={shape}
                      src={item.featuredImage[0].url}
                      srcset={item.featuredImage[0].srcset}
                      sizes={
                        modIndex === 0
                          ? '(min-width: 768px) 90vw, 100vw'
                          : '(min-width: 768px) 50vw, 100vw'
                      }
                      alt={item.featuredImage[0].alt || item.ctaLabel}
                    />
                  )}
                  {item.ctaLink && item.ctaLabel && (
                    <div className="target-groups__grid-cta">
                      <Headline secondary tag="h3" className="target-groups__grid-cta-title">
                        {item.ctaLabel}
                      </Headline>
                      <Link href={item.ctaLink} aria-label={t('learnMore')}>
                        <span className="target-groups__grid-cta-stretched" />
                        <span className="sr-only">{t('learnMoreAbout') + item.ctaLabel}</span>
                        <ArrowRight role="img" ariaLabel={t('learnMoreAbout') + item.ctaLabel} />
                      </Link>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </Container>
    </StyledTargetGroups>
  );
};

TargetGroups.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string,
    targetGroupBlocks: PropTypes.arrayOf(PropTypes.shape())
  })
};

export default TargetGroups;
